module.exports = __webpack_public_path__ + "static/4-8f914540c6fd2de8190d34b50676f1ab.jpeg";